/**
 * AI Checker API 配置常量
 *
 * 包含 Worker URL、超时时间等配置
 */

/**
 * Cloudflare Worker URL
 *
 * 从环境变量读取，默认使用示例 URL
 * 部署后请在 .env.local 中设置实际的 Worker URL
 *
 * @example
 * VITE_WORKER_URL=https://ai-checker.your-subdomain.workers.dev
 */
export const WORKER_URL =
  import.meta.env.VITE_WORKER_URL || 'https://ai-checker.example.workers.dev';

/**
 * API 请求超时时间（毫秒）
 *
 * 默认 15 秒，包含所有端点检测的并行请求时间
 */
export const API_TIMEOUT = 15_000;

/**
 * 扫描进度步骤
 *
 * 用于显示扫描进度动画
 */
export const SCAN_STEPS = [
  { progress: 25, step: 2, label: 'Initializing scan...' },
  { progress: 50, step: 3, label: 'Checking llms.txt...' },
  { progress: 75, step: 3, label: 'Analyzing Schema.org...' },
  { progress: 90, step: 4, label: 'Scanning data endpoints...' },
  { progress: 100, step: 4, label: 'Finalizing results...' },
];

/**
 * 评分等级配置
 */
export const GRADE_CONFIG = {
  'A+': { minScore: 90, color: 'emerald', label: 'Excellent' },
  A: { minScore: 80, color: 'green', label: 'Great' },
  'B+': { minScore: 70, color: 'teal', label: 'Very Good' },
  B: { minScore: 60, color: 'blue', label: 'Good' },
  C: { minScore: 50, color: 'yellow', label: 'Fair' },
  D: { minScore: 40, color: 'orange', label: 'Poor' },
  F: { minScore: 0, color: 'red', label: 'Fail' },
};

/**
 * 状态到显示信息的映射
 */
export const STATUS_MAP = {
  missing: {
    status: 'missing',
    icon: 'close',
    label: 'Missing',
    colorClass: 'text-red-500',
    bgClass: 'bg-red-50',
    borderClass: 'border-red-100',
  },
  detected: {
    status: 'detected',
    icon: 'check_circle',
    label: 'Detected',
    colorClass: 'text-green-600',
    bgClass: 'bg-green-50',
    borderClass: 'border-green-100',
  },
  incomplete: {
    status: 'incomplete',
    icon: 'warning',
    label: 'Incomplete',
    colorClass: 'text-orange-600',
    bgClass: 'bg-orange-50',
    borderClass: 'border-orange-100',
  },
  unknown: {
    status: 'unknown',
    icon: 'help_outline',
    label: 'Unknown',
    colorClass: 'text-gray-500',
    bgClass: 'bg-gray-50',
    borderClass: 'border-gray-100',
  },
};

/**
 * 百分位等级配置
 */
export const PERCENTILE_CONFIG = {
  'Top 5%': { minScore: 80, description: '超过 95% 的网站' },
  'Top 20%': { minScore: 60, description: '超过 80% 的网站' },
  'Top 50%': { minScore: 40, description: '超过 50% 的网站' },
  'Bottom 50%': { minScore: 0, description: '有待提升' },
};
